/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import debounce from 'lodash.debounce';

import * as Actions from "actions";
import {
    TextField, Button, IconButton, Container, Typography, Box, Grid, MenuItem, Stack, Pagination,
} from "@mui/material";
import { Modal, Backdrop, Fade } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import NearMeIcon from '@mui/icons-material/NearMe';

import MockSearchResults from "components/elements/main/MockSearchResults";

import Autocomplete from "@mui/material/Autocomplete";
import UserProductItem from "components/elements/user/products/UserProductItem";
import UserProductDetail from "components/elements/user/products/UserProductDetail";
import UserProductDetailModal from "components/elements/user/products/UserProductDetailModal";
import {H5} from "components/CustomTypography";

import {
    getCategoryBreadcrum,
    getUserProductSortList,
    getCategoryFromID,
    getLocationMarketFromID,
    getLocationBreadcrum,
    isMarketPlaceOnly,
    isFeatureSupported, getLogo, getPlatform, analyticsTrackPageView, analyticsTrackEvent, getURI, isMarketPlace
} from "helpers/utils";

import CustomSectionCreator from "components/CustomSectionCreator";
import MobileCategoryNav from "components/mobile-category-nav";
import UserProductCategorySlider from "components/elements/user/products/UserProductCategorySlider";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import UserShopLocationSlider from "components/elements/user/UserShopLocationSlider";
import CustomFlexBox from "components/CustomFlexBox";
import StoriesPlayer from "components/StoriesPlayer/StoriesPlayer";
import {useLocation} from "react-router-dom";
import UserProductStatusSelector from "components/elements/user/products/UserProductStatusSelector";
import ButtonComponent from "components/Button";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import UserTryOnHistorySlider from "components/elements/user/tryon/UserTryOnHistorySlider";
import UserProductTrackUserViewedSlider from "components/elements/user/products/UserProductTrackUserViewedSlider";

import UnifiedSwipeTrigger from "components/elements/main/UnifiedSwipeTrigger";
import { UnifiedLongPressableObject } from "components/elements/main/UnifiedLongPressableObject";
import UnifiedPullDown from "components/elements/main/UnifiedPullDown";
import UnifiedPullToRefresh from "components/elements/main/UnifiedPullToRefresh";

const UserProductSearch = (props) => {

  const [state, setState] = useState({
    limit: 20,
    hasMoreItems: true,
    breakPoint: "lg",
    bShowSearchModal: false,
    searchvalue: "Search products",
    isShop: false,
  });

  const [productState, setProductState] = useState("");
  const [productModeState, setProductModeState] = useState("PREVIEW");
  const [optionValues, setOptionValues] = useState([]);

    const [categoryState, setCategoryState] = useState("");
    const [colorState, setColorState] = useState("");
    const [locationState, setLocationState] = useState("");
    const [marketState, setMarketState] = useState("");
    const [sortState, setSortState] = useState("popular");
    const [currentPage, setCurrentPage] = useState(1);
    const [showLocationSlider, setShowLocationSlider] = useState(false);

    const [loadStoryState, setLoadStoryState] = useState(false);
    const [loadModalState, setLoadModalState] = useState(false);
    const [loadIdState, setLoadIdState] = useState("");
    const [currentStoryIndex, setCurrentStoryIndex] = useState(null);
    const [showModalProduct, setShowModalProduct] = useState(null);

    const [hasTriedLoading, setHasTriedLoading] = useState(false);

    const {
        serviceError, reqStatus, isLoadingProducts,
        userMainResetSearchProducts, userMainResetsearchKeywords,
        userMainSearchProducts, userMainSearchKeywords,
        userMainGetProductInfo,
        products, productdetail, searchkeywords,
        userMainResetProductDetail,
        userMainAddProductToWishlist,
        userMainGetProductCategories, commonCategoryList, commonColorList, citylocations,
        currency, match, history,
        isLoadingShop, shopId, isShop, marketId, limit, wholesale,
        userDetails, pagination
    } = props;

  const { keywords } = searchkeywords;

  const {
    resetvalue,
  } = state;

  const { query } = match.params;
  let { sort } = match.params;
  const { location } = match.params;
  const { market } = match.params;
  let { category } = match.params;
    const urlparams = useLocation();

    const { categories } = commonCategoryList;

    const closeProductModal = () => setShowModalProduct(null);

    useEffect(() => {

        userMainResetSearchProducts();

        analyticsTrackPageView("/products", "Main Products");

        // Get a specific query parameter
        const checkLoadState = new URLSearchParams(urlparams.search).get('ls');

        if (checkLoadState) {
            if (checkLoadState === "1") {
                setLoadStoryState(true);
            } else if (checkLoadState === "2") {
                setLoadModalState(true);
            }
        }

        const loadIndex = new URLSearchParams(urlparams.search).get('li');

        if (loadIndex) {
            setLoadIdState(loadIndex);
        }

        if (category) {
            setCategoryState(getCategoryFromID(categories, category));
        }

        if (sort) {
            setSortState(sort);
        } else {
            sort = sortState;
        }

        if (query) {
            setHasTriedLoading(false);
            userMainSearchProducts(query, isShop, shopId, limit, sort, category, "", locationState, marketId, currentPage, wholesale);
        } else if (location) {
            // need lat/lng to do query
            setLocationState(location);
            setHasTriedLoading(false);
            userMainSearchProducts(query, isShop, shopId, limit, sort, category, "", location, marketId, currentPage, wholesale);
        } else if (market) {
            setMarketState(market);
            setHasTriedLoading(false);
            userMainSearchProducts(query, isShop, shopId, limit, sort, category, "", locationState, marketId, currentPage, wholesale);
        } else {
            setHasTriedLoading(false);
            userMainSearchProducts("", isShop, shopId, limit, sort, category, "", locationState, marketId, currentPage, wholesale);
        }

    }, []);

    const handleRefresh = () => {
        setHasTriedLoading(false);
        userMainSearchProducts(query, isShop, shopId, limit, sortState, categoryState._id, colorState, locationState, marketId, currentPage, wholesale);
    };

    useEffect(() => {
        if (!isLoadingProducts && products.length > 0 && loadStoryState) {
            openStoriesView();
            setLoadStoryState(false);
        }
    }, [isLoadingProducts, products, loadStoryState]);

    useEffect(() => {
        if (
            loadModalState &&
            products.length > 0 &&
            loadIdState !== "" &&
            products[loadIdState]
        ) {
            openModalView();
            setLoadModalState(false);
        }
    }, [loadModalState, products, loadIdState]);

    useEffect(() => {
        if (!isLoadingProducts) {
            setHasTriedLoading(true);
        }
    }, [isLoadingProducts]);

  const runSearch = (keyword) => {
      userMainResetsearchKeywords();
    setState({ searchquery: keyword });
    setState({ resetvalue: "" });
    history.push(`/products/search/${keyword}`);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      runSearch(e.target.value);
    }
  };

  const setKeyword = (option, type) => {
    if (type === "selectOption") {
      runSearch(option.target.innerText);
    }
  };

  const runKeywordSearch = (value) => {
    setState({ resetvalue: value });
    if ((value.length > 1)) {
        userMainSearchKeywords(value, shopId, isShop);
    }
  };

    const debouncedChangeHandler = useCallback(
        debounce(runKeywordSearch, 300)
        , []);

  const selectKeywordSearch = (value) => {
      history.push(`/products/search/${value}`);
  };

  const handleDelete = () => {
      history.push("/products");
  };


    const handleAddProductFavourite = (prodId) => {
        userMainAddProductToWishlist(prodId);
    };


    // Click on product item from search results
  const handleProductView = (mode, product, index, withStory, reset) => () => {

      if (withStory) {
          setLoadIdState(index);
      }

    if (reset) {
      setProductState({
        selectedProduct: {
            _id: "",
            shop_id: "",
            status: "",
            images: [],
            video: [],
            title: "",
            logo: [],
            area: "",
        },
      });
      setProductModeState(mode);
    } else {

        analyticsTrackEvent("User Interaction", "Main Product Clicked : Story - " + withStory, product.title + " " + product.shop_id + " " + product._id);

        userMainGetProductInfo(product._id);
      setProductState({
          selectedProduct: {
            _id: product._id,
              shop_id: product.shop_id,
            status: product.status,
            images: product.images,
            video: product.video,
            title: product.title,
            logo: product.logo,
            area: product.area,
        },
      });

      // Open modal for VIEWDETAIL mode, otherwise set product mode state
      if (mode === "VIEWDETAIL") {
          setShowModalProduct(product);
      } else {
          setProductModeState(mode);
      }
    }
  };

    const handleViewShop = (product, index) => {
        setProductModeState("VIEWDETAIL");
        history.push(getURI(process.env.REACT_APP_TYPE, "shop_home", product.shop_id, "", ""));
    };

    // Click on product item from stories player
    const handleBuyProduct = (product, index) => {

        userMainGetProductInfo(product._id);
        setProductState({
            selectedProduct: {
                _id: product._id,
                shop_id: product.shop_id,
                status: product.status,
                images: product.images,
                video: product.video,
                title: product.title,
                logo: product.logo,
                area: product.area,
            },
        });

        // Open modal instead of changing view mode
        setShowModalProduct(product);
    };

    const openCategoryList = () => {
        setProductModeState("CATEG");
    };

    const openStoriesView = () => {
        setProductModeState("STORIES");
    };

    const openModalView = () => {
        handleModalView(products[loadIdState], loadIdState)();
        setProductModeState("PREVIEW");
    };

  useEffect(() => {
    setOptionValues(keywords);
  }, [keywords]);

    const handleSortProducts = (event) => {
        setSortState(event.target.value);
        setCurrentPage(1);
        setHasTriedLoading(false);
        userMainSearchProducts(query, isShop, shopId, "", event.target.value, categoryState._id, colorState, locationState, marketId, 1, wholesale);
    };

    const handleCategoryProducts = (event) => {
        setCategoryState(event.target.value);
        setCurrentPage(1);
        setColorState("");
        setHasTriedLoading(false);
        userMainSearchProducts(query, isShop, shopId, "", sortState, event.target.value, "", locationState, marketId, 1, wholesale);
    };

    const handleCategorySelect = (cat) => {
        setProductModeState("PREVIEW");
        setCurrentPage(1);
        setCategoryState(cat);
        setColorState("");
        setHasTriedLoading(false);
        userMainSearchProducts(query, isShop, shopId, "", sortState, cat._id, "" /* reset color */, locationState, marketId, 1, wholesale);
    };


    const handleSelectCategorySet = (cat) => {
        setCurrentPage(1);
        setCategoryState(cat);
        setColorState("");
        setHasTriedLoading(false);
        userMainSearchProducts(query, isShop, shopId, "", sortState, cat._id, "" /* reset color */, locationState, marketId, 1, wholesale);
    };

    const handleSelectColorSet = (color) => {
        setCurrentPage(1);
        setColorState(color);
        setHasTriedLoading(false);
        userMainSearchProducts(query, isShop, shopId, "", sortState, categoryState._id, color, locationState, marketId, 1, wholesale);
    };

    const handleLocationSet = (location) => {
        setCurrentPage(1);
        setLocationState(location.id);
        setHasTriedLoading(false);
        userMainSearchProducts(query, isShop, shopId, "", sortState, categoryState._id, colorState, location.id, marketId, 1, wholesale);
    };


    const setProductStatus = (sort) => {
        setCurrentPage(1);
        setSortState(sort);
        setHasTriedLoading(false);
        userMainSearchProducts(query, isShop, shopId, "", sort, categoryState._id, colorState, locationState, marketId, 1, wholesale);
    };

    const handleRestAll = () => {
        setCurrentPage(1);
        setSortState("");
        setLocationState("");
        setCategoryState("");
        setHasTriedLoading(false);
        userMainSearchProducts(query, isShop, shopId, "", "", "", "", "", "", 1, wholesale);
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
        setHasTriedLoading(false);
        userMainSearchProducts(query, isShop, shopId, "", sortState, categoryState._id, colorState, locationState, marketId, value, wholesale);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };


    const handleResetResultsStory = () => {
        setProductModeState("PREVIEW");
        setLoadIdState("");
    };

    const handleResetProductStory = () => {
        setLoadIdState("");
    };

  const MobileViewOnClick = () => {
    if (window.innerWidth <= 500 && (match.path !== "/products/search")) {
      history.push("/products/search");
    }
  };

    let isModalSearch = false;

    const productsort = getUserProductSortList();

    const sortOptions = productsort.map((item) => {
        const { value, label } = item;
        return (
            <MenuItem value={value}>{label}</MenuItem>
        );
    });

    const categoryFilterOptions = categories.map((item) => {
        const { id, name } = item;
        return (
            <MenuItem value={id}>{name}</MenuItem>
        );
    });

  const renderNoResults = () => (
          <Box
              sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '50px',
              }}
          >
              <ButtonComponent
                  type="primary"
                  variant="outlined"
                  name="Reset"
                  size="medium"
                  onClick={handleRestAll}
              />
          </Box>
  );

    var type = {
        'new': 'Latest Products',
        'popular': 'Popular Products',
        'default': 'Popular Products'
    };

    const handleModalView = (product, index) => (event) => {

        userMainResetProductDetail();

        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        setShowModalProduct(product);

        userMainGetProductInfo(product._id);

        setProductState({
            selectedProduct: {
                _id: product._id,
                shop_id: product.shop_id,
                status: product.status,
                images: product.images,
                video: product.video,
                title: product.title,
                logo: product.logo,
                area: product.area,
            },
        });

    };

  const renderResults = () => (
      <div>
          {/*isFeatureSupported("shopreels") &&
              <CustomFlexBox sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  position: 'fixed',
                  width: '100%',
                  bottom: 70,
                  justifyContent: 'center',
                  zIndex: 'modal'
              }}>
                  <Button
                      sx={{marginRight: '2px'}}
                      size="large"
                      color="primary"
                      variant="contained"
                      onClick={openStoriesView}
                  >
                      <SlideshowIcon /> &nbsp; View as {process.env.REACT_APP_REELS_TAG}
                  </Button>
              </CustomFlexBox>
          */}
          <Grid item container xs={12} sm={12} md={12} lg={12} spacing={2}>
              {products.map((product, index) => (
                  <Grid item key={index} xs={6} sm={3} md={3} lg={3}>
                      <UnifiedLongPressableObject item={product} index={index}
                                                  onLongPress={handleModalView(product, index)}>
                          <UserProductItem
                              product={product}
                              currency={currency}
                              onMainClick={handleModalView(product, index)}
                              onArrowClick={handleProductView("STORIES", product, index, true, false)}
                              onBottomClick={handleModalView(product, index)}
                              /* onBottomClick={handleProductView("VIEWDETAIL", product, index, false, false)} - do not go to direct link */
                          />
                      </UnifiedLongPressableObject>
                  </Grid>
              ))}
          </Grid>
      </div>
  );

    const storiesData = products.map((product, index) => {
        const {id, shop_id, images, video, title, logo, area} = product;

        let stories = [];

        if (video && video.length > 0) {
            let videoimage = (images && images.length > 0) ? (images[0].full_size_cdn && images[0].full_size_cdn.secure_url ? images[0].full_size_cdn.secure_url : images[0].cdn.secure_url) : "";
            stories.push({
                video: video[0].cdn.secure_url,
                videoimage: videoimage
            });
        } else {
            images && images.map((image) => (
                stories.push({
                    image: image.full_size_cdn && image.full_size_cdn.secure_url ? image.full_size_cdn.secure_url : image.cdn.secure_url
                })
            ));
        }


        return (
            {
                user: {
                    avatar: getLogo(logo),
                    name: title,
                    linkTitle1: "View Shop",
                    linkTitle2: "Detail",
                    area: area,
                },
                item: product,
                itemIndex: index,
                favId: id,
                stories: stories,
            }
        );
    });

    const renderResultsAsStories = () => (
        <div>
            <StoriesPlayer
                loadIndex={loadIdState}
                storiesData={storiesData}
                setAsFav={handleAddProductFavourite}
                onButton1Click={handleViewShop}
                onButton2Click={handleBuyProduct}
                onIndexChange={(index) => setCurrentStoryIndex(index)}
                onCancel={() => handleResetResultsStory()}
            />
            <UnifiedSwipeTrigger
                onLeftSwipeComplete={() => setProductModeState("PREVIEW")}
                onRightSwipeComplete={() => handleBuyProduct(products[currentStoryIndex], currentStoryIndex)}
            />
        </div>
    );

    const renderProductDetail = () => (
        <>
            <UserProductDetail
                {...props}
                setState={(value, field) => setProductState({
                    ...state,
                    selectedProduct: {
                        ...selectedProduct,
                        [field]: value,
                    },
                })}
                currency={currency}
                userDetails={userDetails}
                isLoading={isLoadingProducts}
                productdetail={productdetail}
                selectedProduct={selectedProduct}
                onAddToFavlistClicked={handleAddProductFavourite}
                history={history}
                onCancel={() => setProductModeState("PREVIEW")}
                excludeHome={wholesale}
                wholesale={wholesale}
            />
            <UnifiedSwipeTrigger
                onLeftSwipeComplete={() => setProductModeState("PREVIEW")}
            />
        </>
    );

    const renderProductModal = () => (
        <>
            <UserProductDetailModal
                {...props}
                setState={(value, field) => setProductState({
                    ...state,
                    selectedProduct: {
                        ...selectedProduct,
                        [field]: value,
                    },
                })}
                currency={currency}
                userDetails={userDetails}
                isLoading={isLoadingProducts}
                productdetail={productdetail}
                selectedProduct={selectedProduct}
                onAddToFavlistClicked={handleAddProductFavourite}
                history={history}
                onCancel={closeProductModal}
                excludeHome={wholesale}
                wholesale={wholesale}
            />
        </>
    );

    const renderCategoriesNav = () => (
        <>
            <MobileCategoryNav
                categories={categories}
                categoryState={categoryState}
                selectCategoryClicked={handleCategorySelect}
            />
            <UnifiedSwipeTrigger
                onLeftSwipeComplete={() => setProductModeState("PREVIEW")}
            />
        </>
    );

    const renderProductWithStoriesPlayer = (productData) => (

        <div>

            {renderProductDetail()}

            <StoriesPlayer
                storiesData={productData}
                onCancel={() => handleResetProductStory()}
                setAsFav={handleAddProductFavourite}
                onButton1Click={handleViewShop}
                onButton2Click={handleBuyProduct}
                onIndexChange={(index) => setCurrentStoryIndex(index)}
            />
        </div>

    );

  const renderSearchHelp = () => (
      <Container>
          <Box>
              {
                  window.innerWidth <= 500
                  && (match.path === "/products/search")
                  && optionValues.map((element) => (
                      <Box m={2} alignItems="center" width="100%" display="flex" onClick={() => selectKeywordSearch(element.label)}>
                          <Box width="85%">
                              <H5 fontSize={16} ellipsis>
                                  {element.label}
                              </H5>
                          </Box>
                          <Box width="15%">
                              <IconButton disabled align="right" size="small">
                                  <ArrowForwardIcon />
                              </IconButton>
                          </Box>
                      </Box>
                  ))
              }
          </Box>
      </Container>
  );

  const renderSearchModule = () => (
    <>

        {/*      <Container onClick={MobileViewOnClick}>
          <Box mb={2}>
        {
            window.innerWidth <= 500
            && (match.path === "/products/search") ? isModalSearch = true : isModalSearch = false
          }
        <Autocomplete
          id="autocomplete1"
          onClose={setKeyword}
          disableClearable
          freeSolo
          inputValue={resetvalue}
          onOpen={() => setState({ selected: false })}
          value={resetvalue}
          onKeyPress={handleKeyPress}
          onSelect={(input) => debouncedChangeHandler(input.target.value)}
          options={window.innerWidth <= 500 ? [] : optionValues.map((element) => element.label)}
          renderInput={(params) => (
            <TextField
                {...params}
                InputProps={{
                    sx: {
                        height: 44,
                        paddingRight: 0,
                        borderRadius: 0,
                        color: "grey.900",
                        overflow: "hidden",
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "primary.main",
                        },
                    },
                    startAdornment: <SearchOutlinedIcon fontSize="small" />,
                }}
              autoFocus={isModalSearch}
              placeholder={`Search ${process.env.REACT_APP_PRODUCT_TITLE}`}
            />
          )}
        />
        </Box>
      </Container>

        {
            renderSearchHelp()
        }

*/}

      <Container>
      { match.path !== "/"
      && (
          match.path === "/products/search/:query" ||
          match.path === "/products/search/:query" ||
          match.path === "/products" ||
          match.path === "/products/sort/:sort" ||
          match.path === "/products/location/:location" ||
          match.path === "/products/market/:market" ||
          match.path === "/products/category/:category"
      ) && (
      <>

              <Box width="100%" margin="0px">
                  <UserProductCategorySlider
                      {...props}
                      isDirect={false}
                      includeAll={true}
                      openCategoryList={openCategoryList}
                      selectedCategory={categoryState._id}
                      handleSelectCategoryLink={handleSelectCategorySet}
                      handleSelectCategorySet={handleSelectCategorySet}
                      selectedColor={colorState}
                      handleSelectColorLink={handleSelectColorSet}
                      handleSelectColorSet={handleSelectColorSet}

                  />
              </Box>
              { isMarketPlaceOnly() && sortState !== "nearby" && showLocationSlider &&
                  <Box width="100%" margin="0px">
                    <UserShopLocationSlider
                        {...props}
                        isDirect={false}
                        isProduct={true}
                        setLocation={locationState}
                        headerTitle={"By Location: " + (type[sortState] || type['default'])}
                        handleSelectCategoryLink={handleLocationSet}
                        handleSelectCategorySet={handleLocationSet} />
                    </Box>}

          {query ? (<CustomSectionCreator title={"Searching: '" + query + "'"} />) : (<CustomFlexBox bgcolor="header" justifyContent="space-between" alignItems="center" p={1} />)}

          {/*!query && (categoryState ? (<CustomSectionCreator title={getCategoryBreadcrum(categories, categoryState) + getLocationBreadcrum(citylocations, locationState)} />) : (<CustomSectionCreator title={(type[sortState] || type['default']) + getLocationBreadcrum(citylocations, locationState)} />)) */}

          <CustomFlexBox alignItems="center" mt={2} mb={2} sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
          }}>
              <Box width="45%">
                  <UserProductStatusSelector
                      onStatusSelect={setProductStatus}
                      productstatus={sortState}
                  />
              </Box>
              <Box width="25%">
                  <ButtonComponent
                      type="primary"
                      variant="outlined"
                      name="View All"
                      size="medium"
                      onClick={handleRestAll}>
                  </ButtonComponent>
              </Box>
              <Box width="30%" display="flex" justifyContent="flex-end">
                  {isMarketPlaceOnly() && sortState !== "nearby" && (
                      <IconButton
                          onClick={() => setShowLocationSlider(!showLocationSlider)}
                          color="primary"
                          aria-label="toggle location filter"
                      >
                          <NearMeIcon />
                      </IconButton>
                  )}
              </Box>
          </CustomFlexBox>

          {isLoadingProducts ? (
              <MockSearchResults />
          ) : products.length > 0 ? (
              renderResults()
          ) : hasTriedLoading ? (
              renderNoResults()
          ) : null}

          <CustomFlexBox alignItems="center" mb={4} sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
          }}>


              {/* Pagination */}
              {!isLoadingProducts && products.length > 0 && pagination && (
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, mb: 2, width: '100%' }}>
                      <Stack spacing={2}>
                          <Pagination
                              count={pagination.totalPages}
                              page={currentPage}
                              onChange={handlePageChange}
                              color="primary"
                              size="large"
                          />
                      </Stack>
                  </Box>
              )}
          </CustomFlexBox>

          {/*<UserTryOnHistorySlider />*/}

          <UserProductTrackUserViewedSlider includeHeader={true} />
      </>
      )}
      </Container>
    </>
  );

  const renderProductMode = (productMode) => {
    switch (productMode) {

        case "STORIES":
            return renderResultsAsStories();

        case "CATEG":
            return renderCategoriesNav();

        case "STORIESVIEW":

            const {id, shop_id, images, video, title, logo, area} = selectedProduct;

            let productStoryData = [];
            let stories = [];

            if (video && video.length > 0) {
                let videoimage = (images && images.length > 0) ? (images[0].full_size_cdn && images[0].full_size_cdn.secure_url ? images[0].full_size_cdn.secure_url : images[0].cdn.secure_url) : "";
                stories.push({
                    video: video[0].cdn.secure_url,
                    videoimage: videoimage
                });
            } else {
                images && images.map((image) => (
                    stories.push({
                        image: image.full_size_cdn && image.full_size_cdn.secure_url ? image.full_size_cdn.secure_url : image.cdn.secure_url
                    })
                ));
            }


            productStoryData.push(
                {
                    user: {
                        avatar: logo[0].cdn.secure_url,
                        name: title,
                        linkTitle1: "View Shop",
                        linkTitle2: "Detail",
                        area: area,
                    },
                    item: selectedProduct,
                    favId: id,
                    stories: stories,
                }
            );

            return renderProductWithStoriesPlayer(productStoryData);

        case "VIEWDETAIL":
            return renderProductDetail();

        case "PREVIEW":
        default:
            // causes render again on closing stories - reload of objects inside
            return renderSearchModule();
    }
  };

  const { selectedProduct = {} } = productState;

  return (
      <Container>
        {productModeState === "PREVIEW" ? (
          <UnifiedPullToRefresh
            onRefresh={handleRefresh}
            isRefreshing={isLoadingProducts}
          >
            {renderProductMode(productModeState)}
          </UnifiedPullToRefresh>
        ) : (
          renderProductMode(productModeState)
        )}

          <Modal
              open={!!showModalProduct}
              onClose={closeProductModal}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{ timeout: 300 }}
          >
              <Fade in={!!showModalProduct}>
                  <Box>
                      <IconButton
                          onClick={closeProductModal}
                          sx={{
                              position: 'absolute',
                              top: '2%',
                              left: '50%',
                              transform: 'translateX(-50%)',
                              zIndex: 1301,
                              backgroundColor: 'black',
                              color: 'white',
                              width: 48,
                              height: 48,
                              pointerEvents: 'auto',
                              '&:hover': {
                                  backgroundColor: 'grey.800',
                              },
                          }}
                      >
                          <CloseIcon />
                      </IconButton>
                      <Box
                          sx={{
                              position: 'absolute',
                              top: '8%',
                              height: '95%',
                              width: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                          }}
                      >
                          {/* checking showModalProduct._id === selectedProduct._id avoids race condition */}
                          {showModalProduct && selectedProduct && showModalProduct._id === selectedProduct._id && (
                              <>
                                  <Box sx={{
                                      position: 'absolute',
                                      top: '50%',
                                      left: '50%',
                                      transform: 'translate(-50%, -50%)',
                                      width: '96%',
                                      height: '95%',
                                      overflow: 'auto',
                                      boxSizing: 'border-box',
                                      bgcolor: 'background.paper',
                                      borderRadius: 2,
                                      boxShadow: 24,
                                      p: 2,
                                  }}>
                                      <UnifiedPullDown onPullDown={closeProductModal} threshold={60}>
                                          {renderProductModal()}
                                      </UnifiedPullDown>
                                  </Box>
                                  <UnifiedSwipeTrigger
                                      onLeftSwipeComplete={() => { closeProductModal(); setProductModeState("PREVIEW"); }}
                                      onRightSwipeComplete={() => { closeProductModal(); history.push(getURI(process.env.REACT_APP_TYPE, "shop_home", selectedProduct.shop_id, "", "")); }}
                                  />
                              </>
                          )}
                      </Box>
                  </Box>
              </Fade>
          </Modal>

      </Container>
  );


};

UserProductSearch.defaultProps = {
  currency: "",
};

UserProductSearch.propTypes = {
    currency: PropTypes.string,
    bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
    products: PropTypes.arrayOf(PropTypes.any).isRequired,
    pagination: PropTypes.object,
    searchkeywords: PropTypes.objectOf(PropTypes.any).isRequired,
    commonCategoryList: PropTypes.objectOf(PropTypes.any).isRequired,
    commonColorList: PropTypes.objectOf(PropTypes.any).isRequired,
    citylocations: PropTypes.objectOf(PropTypes.any).isRequired,
    userMainSearchProducts: PropTypes.func.isRequired,
    userMainSearchKeywords: PropTypes.func.isRequired,
    userMainResetsearchKeywords: PropTypes.func.isRequired,
    userMainResetSearchProducts: PropTypes.func.isRequired,
    userMainGetProductInfo: PropTypes.func.isRequired,
    userMainAddProductToWishlist: PropTypes.func.isRequired,
    history: PropTypes.objectOf(PropTypes.any).isRequired,
    match: PropTypes.objectOf(PropTypes.any).isRequired,
};

// Mapping Props and State.
const userProductSearch = connect(
  ({ userMainProducts, bootupInfo, userMainShops, userbootupInfo }) => ({
      bootupInfo,
      userbootupInfo,
      userDetails: bootupInfo.userDetails,
      currency: bootupInfo.symbol,
      reqStatus: userMainProducts.reqStatus,
      isLoadingProducts: userMainProducts.isLoading,
      serviceError: userMainProducts.serviceError,
      products: userMainProducts.searchproducts,
      pagination: userMainProducts.pagination,
      searchkeywords: userMainProducts.searchkeywords,
      searchcategorykeywords: userMainProducts.searchcategorykeywords,
      commonCategoryList: userMainProducts.categoryList,
      commonColorList: userMainProducts.colorList,
      citylocations: bootupInfo.citylocations,
      productdetail: userMainProducts.productdetail,
      shopDetail: userMainShops.shopDetail,
      isLoadingShop: userMainShops.isLoading,

  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(UserProductSearch);

export { userProductSearch as default };
